import(/* webpackMode: "eager" */ "/vercel/path0/src/app/client/(app)/layout.tsx");
